module.exports = __webpack_public_path__ + "img/1bombas.bff09d5e.jpg";